import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Box } from '@mui/material';
import React from 'react';
import CircularProgressWithLabel from '../../../../../components/CircularProgressWithLabel';
import useWidth from '../../../../../components/Hooks/useWidth';
import { OrderProductGridItem } from '../../orderProducts.types';
import { useOrderProductStyles } from '../styles/useOrderProductStyles';
import OrderProductStatusTooltipContent from './OrderProductStatusTooltipContent';

interface OrderProductStatusProps {
  grid: OrderProductGridItem[];
}

const OrderProductStatus = ({ grid }: OrderProductStatusProps) => {
  const { classes } = useOrderProductStyles();
  const { mobileWidth } = useWidth();

  const progressCirclePercentage = () => {
    const gridStatus = grid.reduce(
      (acc, gridItem) => ({
        pendingQuantity: acc.pendingQuantity + Number(gridItem.pendingQuantity || 0),
        canceledQuantity: acc.canceledQuantity + Number(gridItem.canceledQuantity || 0),
        settledQuantity: acc.settledQuantity + Number(gridItem.settledQuantity || 0),
      }),
      {
        pendingQuantity: 0,
        canceledQuantity: 0,
        settledQuantity: 0,
      },
    );

    const totalWithoutCanceled = gridStatus.pendingQuantity + gridStatus.settledQuantity;

    return (100 / totalWithoutCanceled) * gridStatus.settledQuantity;
  };

  return (
    <Tooltip TooltipContent={<OrderProductStatusTooltipContent grid={grid} />}>
      <Box className={classes.orderItemProgressStatus}>
        <CircularProgressWithLabel
          value={progressCirclePercentage() || 0}
          type="thick"
          onlyIcon={mobileWidth}
        />
      </Box>
    </Tooltip>
  );
};

export default React.memo(OrderProductStatus);
